module.exports = __webpack_public_path__ + "media/set.99085b84.wav";